import React from 'react';
import { companyInfo } from '../../data/mockData';
import { SocialIcons } from '../SocialIcons';
import { NAV_ITEMS } from './Navigation';

export const MobileMenu = ({ onSelect }) => (
  <div
    style={{
      position: 'absolute',
      top: '100%',
      left: 0,
      right: 0,
      background: 'white',
      borderBottom: '1px solid var(--gray-200)',
      boxShadow: 'var(--shadow-lg)',
      padding: '1rem'
    }}
  >
    <nav style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
      {NAV_ITEMS.map((item) => (
        <button
          key={item.section}
          onClick={() => onSelect(item.section)}
          style={{
            textAlign: 'left',
            padding: '0.75rem',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            borderRadius: '0.5rem',
            fontWeight: 500,
            color: 'var(--primary-navy)'
          }}
          data-testid={`mobile-nav-${item.section}`}
        >
          {item.label}
        </button>
      ))}
      <div style={{ display: 'flex', justifyContent: 'center', padding: '0.5rem 0' }}>
        <SocialIcons variant="light" size={16} />
      </div>
      <button
        onClick={() => window.open(companyInfo.googleCalendarLink, '_blank')}
        className="btn-primary"
        style={{ marginTop: '0.5rem' }}
        data-testid="mobile-schedule-cta"
      >
        Schedule a Consultation
      </button>
    </nav>
  </div>
);
